module.exports = __webpack_public_path__ + "img/success@2x.9ed61251.png";